import React from 'react';
import {
  Col,
  Modal,
  Row,
  Select,
  Table,
} from 'antd';
import PropTypes from 'prop-types';

import CostTrackingAnalysisCard from './CostTrackingAnalysisCard';

export default function CostToDateDetailModal({
  visible,
  onCancel,
  selectedKey,
  onSelectedKeyChange,
  options,
  selectedCard,
  tableColumns,
  tableData,
}) {
  return (
    <Modal
      title="Cost to Date Detail"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width="75vw"
      className="cost-tracking-analysis-detail-modal"
      bodyStyle={{ maxHeight: '70vh', overflowY: 'auto' }}
      destroyOnClose
    >
      <div className="cost-tracking-analysis-detail-modal-body">
        <Row gutter={24}>
          <Col flex="0 0 320px">
            <Select
              className="cost-tracking-analysis-detail-select"
              placeholder="Select cost to date"
              value={selectedKey}
              onChange={onSelectedKeyChange}
              options={options}
              style={{ width: '100%', marginBottom: 16 }}
            />
            {selectedCard && (
              <CostTrackingAnalysisCard card={selectedCard} />
            )}
          </Col>
          <Col flex="1">
            <Table
              className="budget-tracking-table"
              columns={tableColumns}
              dataSource={tableData}
              rowKey="rowKey"
              pagination={false}
              size="small"
              scroll={{ x: 'max-content' }}
              expandable={{
                childrenColumnName: 'children',
                rowExpandable: (row) => (row.children?.length ?? 0) > 0,
              }}
              bordered
            />
          </Col>
        </Row>
      </div>
    </Modal>
  );
}

/* eslint-disable react/forbid-prop-types */
CostToDateDetailModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  selectedKey: PropTypes.string,
  onSelectedKeyChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
  selectedCard: PropTypes.shape({
    key: PropTypes.string,
    title: PropTypes.string,
    estimated: PropTypes.number,
    actual: PropTypes.number,
    hasEstimated: PropTypes.bool,
    estPct: PropTypes.number,
    actPct: PropTypes.number,
    difference: PropTypes.number,
    isFavorable: PropTypes.bool,
  }),
  tableColumns: PropTypes.array,
  tableData: PropTypes.array,
};

CostToDateDetailModal.defaultProps = {
  selectedKey: null,
  selectedCard: null,
  options: [],
  tableColumns: [],
  tableData: [],
};
